import get from 'lodash/get';
import React from 'react';

import { withDocumentTitle } from '../../generic/DocumentTitle';
import add from '../../REST/add';
import api from '../../REST/api';
import { tapFlashSuccess } from '../../utils/flash';
import ContactForm from '../ContactForm';
import {
  transformForPatch,
  transformForRendering,
} from '../transform-contact-helpers';

const defaults = {
  created: '',
  lastModified: '',
  createdBy: '',
  lastModifiedBy: '',
  firstName: '',
  lastName: '',
  title: '',
  description: '',
  email: '',
  mobile: '',
  phone: '',
  fax: '',
};

const AddContactForm = add({
  update: (props, model) =>
    api
      .addContact({
        data: transformForPatch(model, true),
      })
      .then(transformForRendering)
      .then(tapFlashSuccess('Created Contact')),
  form: props => <ContactForm newModel {...props} />,
  redirectTo: '/contacts/:id/show',
});

const AddContactWithDefaultValues = props => {
  const defaultValues = get(props, 'location.state.defaultValues');

  return (
    <AddContactForm {...props} default={{ ...defaults, ...defaultValues }} />
  );
};

export default withDocumentTitle('Create Contact')(AddContactWithDefaultValues);
